import { MixedImage } from "@ui/images/mixed-image";
import { GroupAddIcon } from "@ui/icons/material/GroupAdd";
import { PeopleIcon } from "@ui/icons/material/People";
import { FileDownloadDoneIcon } from "@ui/icons/material/FileDownloadDone";
import clsx from "clsx";
import React, { CSSProperties, JSXElementConstructor } from "react";
import {
  DatabaseNotification,
  DatabaseNotificationLine,
} from "./database-notification";
import { SvgIconProps } from "@ui/icons/svg-icon";
import { useTrans } from "@ui/i18n/use-trans";
import { message } from "@ui/i18n/message";
const iconMap = {
  "group-add": GroupAddIcon,
  people: PeopleIcon,
  "export-csv": FileDownloadDoneIcon,
} as Record<string, JSXElementConstructor<SvgIconProps>>;

interface LineProps {
  notification: DatabaseNotification;
  line: DatabaseNotificationLine;
  index: number;
  imageRenderer?: JSXElementConstructor<{
    image: string;
    className?: string;
    cssProp?: CSSProperties;
  }>;
}

export function Line({ notification, line, index, imageRenderer }: LineProps) {
  const isPrimary = line.type === "primary" || index === 0;
  const Image = imageRenderer || DefaultimageRenderer;
  const Element = line.action ? "a" : "div";
  const { trans } = useTrans();
  return (
    <>
      {(line.content || line.image) && (
        <Element
          key={index}
          className={clsx(
            "flex items-center gap-8",
            line.action && "hover:underline",
            isPrimary
              ? "mt-10 mnarktext-main text-sm"
              : "mt-5 text-xs text-muted",
          )}
          href={line.action?.action}
          title={line.action?.label}
        >
          {line.image && (
            <Image
              image={line.image}
              className="rounded-panel h-300 shadow-md mt-10"
              cssProp={{ width: "100%" }}
            />
          )}
          {line.content && (
            <div
              className="overflow-hidden text-ellipsis"
              dangerouslySetInnerHTML={{
                __html: trans(
                  message(trans(message(line.content)), {
                    values: notification.data.i18n,
                  }),
                ),
              }}
            />
          )}
        </Element>
      )}
    </>
  );
}

interface DefaultimageRendererProps {
  image: string;
  className: string;
  cssProp: CSSProperties;
}
function DefaultimageRenderer({
  image,
  className,
  cssProp,
}: DefaultimageRendererProps) {
  return <MixedImage src={image} className={className} cssProp={cssProp} />;
}
